import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse, okResponseList, notFoundResponse } from '../../utils/response';
import { Token, UserCode, EmployeeCode, Company } from '../../utils/users';
import { encryption } from '../../utils/encryption';

export function subscribe(endpoint, p256dh, auth, language) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        endpointCrypt: encryption(endpoint),
        p256dhKeyCrypt: encryption(p256dh),
        authKeyCrypt: encryption(auth),
        languageStr: language,
        token: Token()
    });
    return fetch('notification/subscribe', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function unsubscribe(endpoint) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        endpointCrypt: encryption(endpoint),
        token: Token()
    });
    return fetch('notification/unsubscribe', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}
